import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Intro from "./sections/Intro";
import Join from "./sections/Join";
import Company from "./sections/Company";
import Request from "./sections/Request";
import Event from "./sections/Event";
import Partner from "./sections/Partner";
import Head from "../Base/Head";

export default function DealmakersIB() {
  const head = {
    title: "Dealmakers IB - Landmark Ventures",
    description:
      "Welcome to the Investment Banking Practice at Landmark Ventures. We provide Corp Dev, M&A (Sell-Side & Buy-Side), Capital Raising (Equity & Debt) and Strategic Advisory services.",
    url: "https://dealmakersIB.landmarkventures.com",
    image: "https://i.imgur.com/0mYyAGB.jpg",
  };

  return (
    <>
      <Head head={head} />
      <div className="industrial-tech dealmakers-ib">
        <Intro />
        {/* <Join /> */}
        {/* <Event /> */}
        <Request />
        <Company />
        {/* <Partner /> */}
      </div>
    </>
  );
}
